import { IIconProps } from '~/types';

const EstimateIcon = ({ fill = '#7B7986', size = 24, strokeWidth = 2, ...props }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.5 21V5a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v16l4-2 4 2 4-2z"
      stroke={fill}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EstimateIcon;
